import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import map from 'lodash/map'
import omit from 'lodash/omit'
import pickBy from 'lodash/pickBy'
import reduce from 'lodash/reduce'
import size from 'lodash/size'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'
import camelCase from 'lodash/camelCase'
import keys from 'lodash/keys'

export default { get, isEqual, map, omit, pickBy, reduce, size, isEmpty, filter, camelCase, keys }


// WEBPACK FOOTER //
// ./src/lib/lodash.js